interface LoadFontMessage {
  type: 'LOAD_FONT';
  fontId: string;
  fontUrl: string;
  priority: number;
}

interface FontLoadedMessage {
  type: 'FONT_LOADED';
  fontId: string;
  fontData: ArrayBuffer;
}

interface FontProgressMessage {
  type: 'FONT_PROGRESS';
  fontId: string;
  progress: number;
}

interface FontErrorMessage {
  type: 'FONT_ERROR';
  fontId: string;
  error: string;
}

type WorkerMessage = LoadFontMessage | FontLoadedMessage | FontProgressMessage | FontErrorMessage;

self.onmessage = async (e: MessageEvent<LoadFontMessage>) => {
  const msg = e.data;

  if (msg.type === 'LOAD_FONT') {
    try {
      const response = await fetch(msg.fontUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const total = parseInt(response.headers.get('content-length') || '0', 10);

      if (!response.body) {
        throw new Error('Response body is null');
      }

      const reader = response.body.getReader();
      let loaded = 0;
      const chunks: Uint8Array[] = [];

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        loaded += value.length;

        // 报告进度
        if (total > 0) {
          const progress = (loaded / total) * 100;
          self.postMessage({
            type: 'FONT_PROGRESS',
            fontId: msg.fontId,
            progress: Math.round(progress)
          } as FontProgressMessage);
        }
      }

      // 合并所有 chunks
      const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
      const arrayBuffer = new Uint8Array(totalLength);
      let offset = 0;
      for (const chunk of chunks) {
        arrayBuffer.set(chunk, offset);
        offset += chunk.length;
      }

      self.postMessage({
        type: 'FONT_LOADED',
        fontId: msg.fontId,
        fontData: arrayBuffer.buffer
      } as FontLoadedMessage, [arrayBuffer.buffer]);

    } catch (error) {
      self.postMessage({
        type: 'FONT_ERROR',
        fontId: msg.fontId,
        error: (error as Error).message
      } as FontErrorMessage);
    }
  }
};

// 导出类型供主线程使用
export type { WorkerMessage, LoadFontMessage, FontLoadedMessage, FontProgressMessage, FontErrorMessage };
